<div *ngIf="user" class="p-grid" style="width: 100%">
  <div class="p-col-12 p-md-4 p-lg-4">
    <label>First Name* </label>
    <div>
      <input pInputText name="eFirstName" type="text" [maxlength]="Validation.NameMaxTextLength" style="width: 88%;border: 1px solid #ccc;padding: 6px 12px;width: 70%;"
             [(ngModel)]="user.firstName" required/>
    </div>
  </div>
  <div class="p-col-12 p-md-4 p-lg-4">
    <label>Last Name* </label>
    <div>
      <input pInputText name="eLastName" type="text" [maxlength]="Validation.NameMaxTextLength" style="width: 88%;border: 1px solid #ccc;padding: 6px 12px;width: 70%;"
             [(ngModel)]="user.lastName" required/>
    </div>
  </div>
  <div class="p-col-12 p-md-4 p-lg-4">
    <label>Middle Name </label>
    <div>
      <input pInputText name="eMiddleName" type="text" [maxlength]="Validation.TextMaxLength" style="width: 88%;border: 1px solid #ccc;padding: 6px 12px;width: 70%;"
             [(ngModel)]="user.middleName"/>
    </div>
  </div>


  <div class="p-col-12 p-md-4 p-lg-4">
    <label>E-Mail* </label>
    <div>
      <input pInputText name="pEmail" type="email" [pattern]="RegExpEmail" [maxlength]="Validation.WorkEmailMaxLength" style="width: 88%;border: 1px solid #ccc;padding: 6px 12px;width: 70%;"
             [(ngModel)]="user.workEmail" required>
    </div>
  </div>
  <div class="p-col-12 p-md-4 p-lg-4">
    <label>Office Phone*</label>
    <div>
      <app-international-phone-number name="officePhone" [(ngModel)]="user.officePhone" required></app-international-phone-number>
    </div>
  </div>
  <div class="p-col-12 p-md-4 p-lg-4">
    <label>Mobile Phone</label>
    <div>
      <app-international-phone-number name="mobilePhone" [(ngModel)]="user.mobilePhone"></app-international-phone-number>
      <label style="padding:5px 5px 0 5px;">Send SMS </label>
      <p-checkbox name="sendSms" binary="true" style="position: relative;top:-5px;"
                  [(ngModel)]="user.sendSms"
                  [disabled]="!checkIfUsPhoneNumber(user.mobilePhone)"></p-checkbox>
    </div>
  </div>

  <div class="p-col-12 p-md-4 p-lg-4">
    <label>Title</label>
    <div>
      <input pInputText name="title" type="text" [maxlength]="Validation.TextMaxLength" style="width: 88%;border: 1px solid #ccc;padding: 6px 12px;width: 70%;"
             [(ngModel)]="user.title"/>
    </div>
  </div>
  <div class="p-col-12 p-md-4 p-lg-4">
    <label>Location</label>
    <div>
      <p-dropdown name="location" [placeholder]="PrimeNgConfig.DropdownPlaceholder"
                  [options]="locationsDropDown" [showClear]="true"
                  [(ngModel)]="user.locationId">
      </p-dropdown>
    </div>
  </div>
</div>
